export const typeRepresentation = [
  { codigo: 'private', etiqueta: 'Privado' },
  { codigo: 'public', etiqueta: 'Público' },
];
